module.exports = __webpack_public_path__ + "img/arrow-select-field.0bb8fb0e.svg";